import React, {useState} from 'react'
import {Button, IconButton, Timeline} from '@primer/react'
import {ChevronDownIcon, ChevronRightIcon} from '@primer/octicons-react'
import {Link} from '@github-ui/react-core/link'
import type {EventGroup} from '../../../helpers/catch-up-helpers'
import {EventList} from '../ActivityEventList'
import styles from '../Activity.module.css'

interface ActivityGroupProps {
  item: EventGroup
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
}

export function ActivityGroup({item, icon: Icon}: ActivityGroupProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  const onToggle = () => setIsExpanded(prev => !prev)
  const linkText = item.linkText || `View ${item.label.toLowerCase()}`
  const ChevronIcon = isExpanded ? ChevronDownIcon : ChevronRightIcon
  const isToggleable = item.events.length > 0
  return (
    <Timeline clipSidebar>
      <Timeline.Item>
        <Timeline.Badge>
          <Icon />
        </Timeline.Badge>
        <Timeline.Body>
          <div className={styles.activityHeader}>
            <span className={styles.activityLabel}>{item.label}</span>
            {isToggleable && <span className={styles.activityHeaderSpacer} onClick={onToggle} aria-hidden="true" />}
            <div className={styles.activityActions}>
              {item.link && (
                <Button as={Link} to={item.link} size="small" variant="invisible" aria-label={linkText}>
                  {linkText}
                </Button>
              )}
              {isToggleable && (
                <IconButton
                  icon={ChevronIcon}
                  size="small"
                  variant="invisible"
                  onClick={onToggle}
                  aria-expanded={isExpanded}
                  aria-label={`${isExpanded ? 'Hide' : 'Show'} details for ${item.label.toLocaleLowerCase()}`}
                />
              )}
            </div>
          </div>
          {isExpanded && (
            <div className={styles.activityDetails}>
              <EventList events={item.events} />
            </div>
          )}
        </Timeline.Body>
      </Timeline.Item>
    </Timeline>
  )
}
